import React, { useContext } from 'react';
import constants from '../context/constants';
import { PageContext } from './provider';
import Countdown from 'react-countdown';
import Clock from 'react-live-clock';
import { initConfigs } from '../context/constants';
import companyLogo from '../assets/Maropost-Logo-Light-H.svg';

const Header = () => {
    const { state, dispatch } = useContext(PageContext);

    const statusText = value => {
        switch (value) {
            case constants.PAGE_STATUS_LOADING:
                return 'Loading';
            case constants.PAGE_STATUS_LOADED:
                return (<span><li className='live-icon'/><span className={'status'}>Live</span></span>);
            case constants.PAGE_STATUS_ERROR:
                return 'Offline';
            default:
                return 'Loading';
        }
    };

    const pauseButtonText = value => {
        if (value) {
            return '| |';
        }
        return '►';
    };

    const handleToggleAutoRotate = () => {
        dispatch({ type: constants.UPDATE_AUTO_ROTATE, data: !state.autoRotate });
    };

    const rendererCountDown = ({ days, hours, minutes, seconds, completed }) => {
        const dayString = (days === 1 ? 'day' : 'days');
        const hourString = (hours === 1 ? 'hour' : 'hours');
        const minuteString = (minutes === 1 ? 'minute' : 'minutes');
        const secondString = (seconds === 1 ? 'second' : 'seconds');

        if (completed) {
            return (
                <span className={'clock'}>
                    <Clock format={'ddd MMM d - HH:mm:ss'} ticking={true} timezone={'Australia/Sydney'}/>
                    {' '}AEST
                </span>
            );
        }

        return (
            <span>
                <span className={'countdown'}>
                    {days ? (days + ' ' + dayString) : ''}{' '}
                    {hours ? (hours + ' ' + hourString) : ''}{' '}
                    {!days && (minutes || seconds) ? (minutes + ' ' + minuteString) : ''}{' '}
                    {!days ? (seconds + ' ' + secondString) : ''}
                </span>
                {' '}remain!
            </span>
        );
    };

    return (
        <div className='header'>
            <div className='header-links'>
                <a href='//id.maropost.com/#/login'
                   target='_blank'
                   rel='noopener noreferrer'
                   className='header-button'>Login</a>
                <button onClick={handleToggleAutoRotate}
                    className='stop-button'>{pauseButtonText(state.autoRotate)}</button>
            </div>

            <a href='https://www.maropost.com/' target='_blank' rel='noopener noreferrer'>
                <img
                    alt="Maropost logo"
                    height="104"
                    width="400"
                    src={companyLogo}
                />
            </a>
            <div>
                <label className='live-label'>{ statusText(state.pageStatus) }</label>
                <span className='live-countdown'><Countdown
                    date={initConfigs.countDown}
                    renderer={rendererCountDown}
                /></span>
            </div>
        </div>
    );
};

export default Header;
